<template>
  <div class="empty-small" :style="wrapStyle">
    <div class="empty-small-title">
      <slot name="title">{{ title }}</slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'EmptySmall',
  props: {
    title: {
      type: String,
      default: '',
    },
    wrapStyle: {
      type: Object,
    },
  },
};
</script>
<style lang="scss" scoped>
.empty-small {
  background: url('~@/assets/images/common/empty-small@2x.png') no-repeat center center/221px 153px;
  height: 153px;
}
.empty-small-title {
  color: #999999;
  line-height: 20px;
  text-align: center;
  padding-top: 128px;
}
</style>
